<template lang="pug">
.wrapper(:class = "slideWrapper")
  #createnew
    span.label Home
  .page-header.home
    .content-center
      #divider.row
      #editmodal.row
        .card
          .card-body.left
            .editform
              div.title Provider Submission
              vue-form(:state="formstate")
                fieldset()
                  validate(tag="label")
                    //multiselect(:options="sampleOptions" v-model="sampleValue" :multiple="false" name="select")
                    span.title(v-tooltip="")  Group
                    fg-input(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.group" required="" name="group" placeholder="group")
                  validate(tag="label")
                    span.title(v-tooltip="") Date of Service
                    fg-input(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.origin" name="origin" type="" required="" placeholder="01/01/2020")
                  validate(tag="label")
                    span.title(v-tooltip="") Procedure Codes
                    fg-input.codes(autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.origin" name="origin" type="" required="" placeholder="")
            span.export.nav-item.lookup(to='/login')
              a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'submit')")
                p Submit
          .card-body.floatright
            span.create.nav-item.lookup(to='/login') 
              a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'create')")
                p Create
                p.label New Entity Wizard
            span.import.nav-item.lookup(to='/login')
              a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'import')")
                p Import
                p.label Import Data
            span.export.nav-item.lookup(to='/login')
              a.nav-link.btn.btn-primary.login(v-on:click="$eventBus.$emit('log', 'export')")
                p Export
                p.label Export Data
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'
  import { mapState } from 'vuex'
  export default {
    name: 'home',
    bodyClass: 'home',
    components: {
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
      updated: false,
    button: 'OK',
    title: '',
    username: this.$store.getters.get('user').username,
    groupSelect: false,
    sampleValue: null,
    sampleOptions: ['Client', 'Business Line', 'Group', 'Procedure', 'Instructions', 'Program'],
    editsample: false,
    formDisabled: false,
    sampleDisabled: false,
    formstate: {},
    running: false,
		form: { agree: false },
    model : {},
    newSample: {
      public: 0,
      group: 'test',
      sample: 'test',
      ethnicity: 'test',
      description: 'test',
      age: 2019,
      origin: 'test',
      coords: '',
      coords2: '',
    }
      }
    },
    updated() {      
            //console.log(this.updated, this.slideWrapper);
            if ( this.updated === false && this.slideWrapper === 'visible' ) {
            this.$store.commit('change', { slideWrapper: 'hidden' })
            setTimeout(() => { this.$store.commit('change', {slideWrapper: 'visible'});
            this.updated = true;
            }, 200)
            }
            },
      watch: {
          $route(to, from) {
          }
      },
    mounted() {
            this.$store.commit('change', { slideWrapper: 'visible' })
    },
      computed: {
          ...mapState({
              gql: 'gql', 
              slideWrapper: 'slideWrapper'
          }),
          },
    methods: {
              editSamples: function(event) {
                          this.$modal.show('editsample', { action: 'add', index: {} });
                                },
                                            }
  }
</script>
<style>
#app .section.divider {
    background: #cacaca;
        border-bottom: 1px solid white;
        }
#app .wrapper {
    transform: translateX(0%);
        transition: transform 0.5s;
        }
        #app .wrapper.hidden {
            transform: translateX(-100%);
            }

body.home #app  .page-header.home .content-center {
    position: absolute;
    top: 140px;
    left: 50%;
    z-index: 2;
    -webkit-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);
    text-align: center;
    color: #FFFFFF;
    padding: 0 15px;
    width: 100%;
    max-width: 880px;
}
.el-switch__label * {
font-size: 10px;
}
#app .page-header .content-center .title {
cursor: default;
}
#app .page-header .content-center h4 {
margin-top: -15px;
cursor: default;
}
#app #createnew {
z-index: +1;
position: absolute;
left: 130px;
top: 80px;
font-size: 2em;
color: white;
cursor: default;
}
#app #createnew i {
position: absolute;
margin-left: 20px;
font-size: 1.5em;
cursor: pointer;
color: #098b5b;
color: #055258;
}
#app  .page-header.page-header-small {
    min-height: 100vh; 
    max-height: 100vh;
        }
#app .input-group-text {
    background-color: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 30px;
    color: #555;
    -webkit-transition: color .3s ease-in-out,border-color .3s ease-in-out,background-color .3s ease-in-out;
    transition: color .3s ease-in-out,border-color .3s ease-in-out,background-color .3s ease-in-out
}
#app span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #055258;
}

#editmodal ::placeholder {
font-weight: 400;
}

#editmodal fieldset[disabled] .form-control {
background-color: #ffffff;
}

#editmodal input.vf-valid {
color: #096b94;
font-weight: 700;
}
#editmodal input.vf-invalid {
color: brown;
font-weight: 700;
}
#editmodal .form-control[disabled] {
background-color: white;
    color: #999;
        font-size: 1em;
            margin-left: 15px;
                cursor: not-allowed;
                }

#editmodal fieldset[disabled] .btn-primary:disabled {
display: none;
}
.v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: 0px;
    right: 0px;
    display: inline;
    float: right;
    z-index: 9;
}
#app #editmodal .v--modal button.closedialog:hover {
box-shadow: none;
}
#app #editmodal .v--modal button.closedialog:active {
background: #9797971c;
}
span.modaltitle {
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    padding-top: 10px;
    color: #0f5579;
}
.infomsg, .validmsg, .errmsg {
font-size: 0.9em;
text-align: left;
padding-left: 20px;
color: #a2a2a2;
}
.errmsg {
color: rgba(255,0,0,0.7);
}
#editmodal .v--modal-box {
margin-top: 50px;
}

#editmodal .fas.fa-check {
color: green;
}

#editmodal .mr-auto {
height: 100%;
}
#editmodal .card {
height: 100%;
display: flex;
flex-direction: row;
}
#editmodal .el-switch {
height: 46px;
padding-bottom: 10px;
}
div.settings {
    display:grid;
    grid-template-columns: max-content max-content;
    grid-gap:5px;
}
div.settings label       { text-align:right; }
div.settings label:after { content: ":"; }
label {
width: 70%;
margin-left: 30%;
}
#editmodal .addrawdna:hover {
    opacity: 1;
    }
#editmodal .addrawdna {
    opacity: 0.7;
    background-color: white !important;
    color: #206096;
    font-size: 16px;
    border: 1px solid #206096;
font-size: 16px;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 8px;
    left: 23px;
box-shadow: none;
z-index: +9;
}
#editmodal span.title {
font-weight: 400;
    padding-top: 8px;
    position: absolute;
    right: 72%;
    text-align: right;
    z-index: 1;
}
#app #editmodal span.subtext {
    font-weight: 400;
    font-size: 20px;
    padding-top: 3px;
    position: absolute;
    width: 30%;
    left: 0px;
    color: brown;
    text-align: right;
}

#app #editmodal .card {
padding: 50px 20px;
}

#editmodal .break>input {
    word-wrap: break-word;
    word-break: break-all;
    height: 80px;
}

        
#app .content-center #editmodal .editform span.title {
    font-weight: 700;
    padding-top: 8px;
    position: absolute;
    right: 80%;
    text-align: right;
    z-index: 1;
    color: gray;
            font-size: 1.1em;
}
#app .card-body.left {
    -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
            flex: 1 1 auto;
                padding: 1.25rem;
                    }
#app .page-header.home .card-body.left {
                    width: 50%;
                    }

#app .content-center .editform label {
    width: 53%;
        margin-left: 33%;
        }

body.home .form-control {
background-color: white;
}
body.home .card-body label {  
font-size: 1em;
font-weight: 700;
color: gray;
}
body.home .card {
    background: transparent;
        box-shadow: none;
            border: 1px solid white;
                border-radius: 9px;
                    min-height: 400px;
                    }
body.home .card-body.floatright p.label {  
    color: gray;
        position: absolute;
            left: -172px;
                top: 3px;
                    text-align: right;
                        width: 140px;
            }
 body.home .card-body input {
 border-radius: 7px;
 }
 body.home .card-body.floatright {
     border-left: 1px solid white;
         width: 40%;
         padding-right: 20px;
         }
body.home #app .card-body.left a.nav-link.btn.btn-primary.login {
position: absolute;
    bottom: 26px;
        margin-left: 110px;
        }
body.home #app .card-body a.nav-link.btn.btn-primary.login {
width: 100px;
position: relative;
left: 220px;
}
body.home div.title {
    color: #454141;
    text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.5);
    color: #787878;
    color: #06593b;
    color: #484747;
    text-shadow: 0px 1px 1px #ffffff;
    font-weight: 700;
    font-size: 1.5em;
    left: 24px;
    top: -18px;
    position: absolute;
    z-index: 2;
}
body.home .codes input {
height: 120px;
}
</style>
